import axios from 'axios';
import { operonIdUrl, clientId, secretId, redirectUrl, apiEndpoint } from '../../settings';
import types from '../actionTypes';
import { setLocalStorage } from '../../utils/helpers';
import { redirect } from './app';
import { logOut } from '../../utils/operon';

export const logout = (redirect) => {
	setLocalStorage('token', null);
	logOut(redirect);
	return (dispatch) => {
		dispatch({ type: types.LOGOUT });
	};
};
export const getUserData = (user) => ({ type: types.GET_USER_DATA, user });

export const login = (token, code) => {
	return (dispatch) => {
		if (token) {
			axios
				.post(operonIdUrl + 'user.php?access_token=' + token)
				.then((res) => res.data)
				.then((data) => {
					if (data['rejestracja'][0] !== '1') {
						dispatch(logout('http://konto.operon.pl/user/register2'));
					} else if (data['potw_email'][0] !== '1' || Number(data['crm_id'][0]) < 1) {
						dispatch(logout('http://konto.operon.pl/user/activate'));
					} else if (data.id) {
						dispatch(getUserData(data));
						dispatch(redirect('/'));
					} else {
						dispatch({ type: types.SET_API_ERROR, state: true });
					}
				})
				.catch((error) => {
					console.log(error);
				});
		} else if (code) {
			axios
				.post(
					operonIdUrl + 'token.php',
					JSON.stringify({
						grant_type: 'authorization_code',
						client_id: clientId,
						client_secret: secretId,
						code,
						redirect_uri: redirectUrl,
					})
				)
				.then((res) => res.data)
				.then((data) => {
					setLocalStorage('token', data.access_token);
					dispatch({ type: types.LOGIN, payload: data.access_token });
					dispatch(redirect('/'));
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			dispatch({ type: types.LOGOUT });
		}
	};
};

export const loginDemo = () => {
	return (dispatch) => {
		const dataFormData = new FormData();
		dataFormData.append('funkcja', 'login_demo');
		axios({
			method: 'post',
			url: apiEndpoint,
			data: dataFormData,
		}).then((res) => {
			dispatch({
				type: types.LOGIN_DEMO,
				id: res.data.id,
				state: true,
				levels_subjects_topics: res.data.poziomy_przedmioty_tematy,
			});
		});
	};
};
